import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useMatches } from './useMatches';
import { useTenantInquiries } from './useTenantInquiries';

export const useNotifications = () => {
  const { currentUser } = useAuth();
  const { matches, loading } = useMatches();
  const { inquiries, loading: inquiriesLoading } = useTenantInquiries(currentUser?.uid);

  const hasUnreadMessages = useMemo(() => {
    if (!currentUser) return false;

    // Unread in a tenant↔tenant match chat…
    const unreadMatch = matches.some(
      (match) => (match.unreadCount?.[currentUser.uid] || 0) > 0
    );
    // …or in a 3-way landlord inquiry chat.
    const unreadInquiry = inquiries.some(
      (inquiry) => (inquiry.chatUnread?.[currentUser.uid] || 0) > 0
    );
    return unreadMatch || unreadInquiry;
  }, [matches, inquiries, currentUser]);

  const hasNewMatches = useMemo(() => {
    if (!matches.length) return false;
    
    // Consider matches from the last 24 hours as "new"
    const oneDayAgo = new Date();
    oneDayAgo.setHours(oneDayAgo.getHours() - 24);
    
    return matches.some(match => {
      if (!match.matchedAt) return false;
      
      // Firestore Timestamp -> Date
      const matchedDate = match.matchedAt.toDate();
      return matchedDate > oneDayAgo;
    });
  }, [matches]);

  return {
    hasUnreadMessages,
    hasNewMatches,
    loading: loading || inquiriesLoading,
  };
};
